import { connect } from 'react-redux';

import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import SearcherFilteredEmpty from '../../components/Searcher/SearcherFilteredEmpty';
import { getSearcherCarouselDate } from '../../store/selectors/searcher';
import { clearSearcherFiltersAction } from '../../store/actions/searcher';

const mapStateToProps = (state) => ({
  date: getSearcherCarouselDate(state),
  isMobile: getIsMobile(state),
  isHotelOnly: getIsHotelOnly(state),
});

const mapDispatchToProps = {
  onClick: clearSearcherFiltersAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearcherFilteredEmpty);
